import I18n from 'I18n';
import { List } from 'immutable';
import { parseExpression } from '../../dataset/expression-utils';
import { withStaticTypeDependencies } from '../../dataset/expression-meta';
import { FormatTypes } from './format-models';
import { ExpressionField } from './column-records';
import { getTableList } from '../utils/table-utils';
import { datasetFieldsListToMap, expressionFieldToDatasetField } from '../utils/expression-field-utils';
import { checkViolations } from '../utils/expression-validation-utils';
import { isNotNull } from '../../shared/lib/utility-types';
import { indexBy } from '../../shared/lib/utils';
const createEmailOpenRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.unique_opened]) / SUM([${tableName}.delivered])`;
  const openRateExpression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(openRateExpression, deps);
    return ExpressionField({
      alias: 'hs_open_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-open-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression: openRateExpression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailDeliveryRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.delivered]) / SUM([${tableName}.scheduled])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_delivered_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-delivered-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailReplyRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.replied]) / SUM([${tableName}.delivered])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_reply_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-reply-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailClickRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.unique_clicked]) / SUM([${tableName}.delivered])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_click_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-click-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailClickThroughRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.unique_clicked]) / SUM([${tableName}.unique_opened])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_click_through_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-click-through-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailBounceRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.bounced]) / SUM([${tableName}.scheduled])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_bounce_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-bounce-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailSpamReportRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.unique_spam_reports]) / SUM([${tableName}.delivered])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_spam_report_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-spam-report-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailContactsLostRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.contacts_lost]) / SUM([${tableName}.scheduled])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_contacts_lost_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-contacts-lost-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailNotSentRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.not_sent]) / SUM([${tableName}.scheduled])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_not_sent_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-not-sent-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailHardBouncedReportRate = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.hard_bounced]) / SUM([${tableName}.scheduled])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_hard_bounce_report_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-hard-bounced-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailSoftBouncedReportRate = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.soft_bounced]) / SUM([${tableName}.scheduled])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_soft_bounce_report_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-soft-bounced-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailUnsubscribeRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.unsubscribed]) / SUM([${tableName}.delivered])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_unsubscribe_rate',
      label: I18n.text('reporting-snowflake.field-labels.email-unsubscribe-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createEmailEventsDigestCalcs = (deps, tableName) => {
  const expressionFields = [createEmailOpenRateField(deps, tableName), createEmailDeliveryRateField(deps, tableName), createEmailUnsubscribeRateField(deps, tableName), createEmailReplyRateField(deps, tableName), createEmailClickRateField(deps, tableName), createEmailClickThroughRateField(deps, tableName), createEmailBounceRateField(deps, tableName), createEmailSpamReportRateField(deps, tableName), createEmailHardBouncedReportRate(deps, tableName), createEmailSoftBouncedReportRate(deps, tableName), createEmailContactsLostRateField(deps, tableName), createEmailNotSentRateField(deps, tableName)].filter(isNotNull);
  return List(expressionFields);
};
const createFormConversionRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.submissions]) / SUM([${tableName}.views])`;
  const conversionsRateExpression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(conversionsRateExpression, deps);
    return ExpressionField({
      alias: 'hs_conversion_rate',
      label: I18n.text('reporting-snowflake.field-labels.form-conversion-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression: conversionsRateExpression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createFormConversionsCalcs = (deps, tableName) => {
  const expressionFields = [createFormConversionRateField(deps, tableName)].filter(isNotNull);
  return List(expressionFields);
};
const createFormSubmissionsCountField = (deps, tableName) => {
  const expressionString = `DISTINCT_COUNT([${tableName}.e_form_submission_metadata_v2/__hs_event_native_idempotency_id])`;
  const submissionsExpression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(submissionsExpression, deps);
    return ExpressionField({
      alias: 'hs_submissions_count',
      label: I18n.text('reporting-snowflake.field-labels.form-submissions'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression: submissionsExpression,
      type,
      context,
      formatHint: FormatTypes.NUMBER
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createCtaClickRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.cta_click]) / SUM([${tableName}.cta_view])`;
  const clickRateExpression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(clickRateExpression, deps);
    return ExpressionField({
      alias: 'cta_click_rate',
      label: I18n.text('reporting-snowflake.field-labels.cta-click-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression: clickRateExpression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createCtaSubmissionRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.cta_form_submission]) / SUM([${tableName}.cta_view])`;
  const submissionRateExpression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(submissionRateExpression, deps);
    return ExpressionField({
      alias: 'cta_submission_rate',
      label: I18n.text('reporting-snowflake.field-labels.cta-submission-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression: submissionRateExpression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createFormSubmissionsCalcs = (deps, tableName) => {
  const expressionFields = [createFormSubmissionsCountField(deps, tableName)].filter(isNotNull);
  return List(expressionFields);
};
const createCtaActivisiesCalcs = (deps, tableName) => {
  const expressionFields = [createCtaClickRateField(deps, tableName), createCtaSubmissionRateField(deps, tableName)].filter(isNotNull);
  return List(expressionFields);
};
const createSmsDeliveryRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.sms_delivered]) / SUM([${tableName}.sms_sent])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_sms_delivered_rate',
      label: I18n.text('reporting-snowflake.field-labels.sms-delivered-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createSmsClickRateField = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.sms_unique_clicked]) / SUM([${tableName}.sms_delivered])`;
  const expression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(expression, deps);
    return ExpressionField({
      alias: 'hs_sms_click_rate',
      label: I18n.text('reporting-snowflake.field-labels.sms-click-rate'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      expression,
      type,
      context,
      formatHint: FormatTypes.PERCENTAGE
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createSmsEventsDigestCalcs = (deps, tableName) => {
  const expressionFields = [createSmsDeliveryRateField(deps, tableName), createSmsClickRateField(deps, tableName)].filter(isNotNull);
  return List(expressionFields);
};
const createDerivedReaction = (deps, tableName) => {
  const expressionString = `SUM([${tableName}.hs_delta_likes]+[${tableName}.hs_delta_reactions_angries]+
  [${tableName}.hs_delta_reactions_loves]+[${tableName}.hs_delta_reactions_hahas]+
  [${tableName}.hs_delta_reactions_thankfuls]+[${tableName}.hs_delta_reactions_wows]+
  [${tableName}.hs_delta_reactions_sads]+[${tableName}.hs_delta_reactions_others])`;
  const derivedReactionExpression = parseExpression(expressionString);
  try {
    const {
      type,
      context
    } = checkViolations(derivedReactionExpression, deps);
    return ExpressionField({
      alias: 'hs_derived_reactions',
      label: I18n.text('reporting-snowflake.field-labels.derived-reactions'),
      derived: true,
      hidden: true,
      // hide from the list of expressions they can edit
      valid: true,
      input: '',
      editor: {
        editorType: 'RELATIONAL_BUILDER',
        editorState: {
          treatNullsAsZero: true
        }
      },
      expression: derivedReactionExpression,
      type,
      context,
      formatHint: FormatTypes.NUMBER
    });
  } catch (e) {
    console.error(e);
    return undefined;
  }
};
const createSocialPostRefeshCalcs = (deps, tableName) => {
  const expressionFields = [createDerivedReaction(deps, tableName)].filter(isNotNull);
  return List(expressionFields);
};
export const createTemplateCalcs = (tableAndPropertyMeta, reportDefinition, gates) => {
  const deps = withStaticTypeDependencies({
    fields: datasetFieldsListToMap(List(reportDefinition.expressions.map(expressionFieldToDatasetField))),
    properties: tableAndPropertyMeta.datasetProperties || tableAndPropertyMeta.properties
  });
  const tableDescriptions = getTableList(reportDefinition.table);
  const mapOfTableNameToDescription = indexBy(tableDescriptions, (_, table) => table.name);
  return mapOfTableNameToDescription.map(table => {
    if (table.eventsDigestType === 'EMAIL_EVENTS') {
      // todo make a constant for "EMAIL_EVENTS"
      return createEmailEventsDigestCalcs(deps, table.name);
    } else if (table.eventsDigestType === 'FORM_CONVERSIONS') {
      return createFormConversionsCalcs(deps, table.name);
    } else if (table.datasourceId === 'V_FORM_SUBMISSIONS') {
      return createFormSubmissionsCalcs(deps, table.name);
    } else if (table.eventsDigestType === 'SMS_EVENTS') {
      return createSmsEventsDigestCalcs(deps, table.name);
    } else if (table.eventsDigestType === 'CTA_ACTIVITIES') {
      return createCtaActivisiesCalcs(deps, table.name);
    } else if (table.name === 'e_social_post_stats_refreshed') {
      return createSocialPostRefeshCalcs(deps, table.name);
    }
    return List();
  }).toMap();
};